import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { useParams } from 'react-router'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { MemberStore } from 'pages/settings/pages/members/store/memberStore'
import { useSettingsContext } from 'pages/settings/context/settingsContext'

export const MemberContext = createContext<MemberStore | null>(null)

export const useMemberContext = () => {
  const context = useContext(MemberContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with MemberContext')

  return context
}

export const MemberProvider = ({ children }: PropsWithChildren) => {
  const { id } = useParams<{ id: string }>()

  const entities = useEntitiesContext()
  const settings = useSettingsContext()
  const numericId = id ? Number(id) : null
  const store = useMemo(() => new MemberStore(numericId, entities, settings), [id])

  useEffect(() => {
    store.init()

    return store.reset
  }, [store])

  return <MemberContext.Provider value={store}>{children}</MemberContext.Provider>
}
